import React from 'react';
import { SectionContainer } from '../components/SectionContainer';
import SectionTitle from '../components/SectionTitle';
import { SectionBody } from '../components/SectionBody';
import { SectionLine } from '../components/SectionLine';
import { FormikPremiumInput } from 'modules/emergencies/components/ui/inputs/customInput';
import { CheckboxsContainer } from '../components/CheckboxsContainer';
import Checkbox from '../components/Checkbox';
import SpecialLabel from '../components/SpecialLabel';
import SpecialLabelText from '../components/SpecialLabelText';
import VehicleDetailsIcon from 'assets/icons/xpo/vehicle-details.svg';

export const ServiceTypeSection = ({ ticketFormBodyData }) => {
  const { showErrors, isReadOnly, draftErrors, initialValues, values } = ticketFormBodyData;

  const draftVehicleTypeError = !!draftErrors?.order_data?.service_type?.vehicle_type;

  const isVehicleTypeUntouched =
    values.order_data.service_type.vehicle_type ===
    initialValues.order_data.service_type.vehicle_type;

  const hasVehicleTypeError = isVehicleTypeUntouched && draftVehicleTypeError;

  const availableVehicleDetails = [
    {
      value: 'Courtain-sider',
      label: 'Curtain-sider',
    },
    {
      value: 'Hanging garment',
      label: 'Hanging Garment',
    },
    {
      value: 'Box',
      label: 'Box',
    },
    {
      value: 'Reel holder',
      label: 'Reel Holder',
    },
    {
      value: 'Tail lift',
      label: 'Tail Lift',
    },
    {
      value: 'Fridge',
      label: 'Fridge',
    },
    {
      value: 'Retractable roof',
      label: 'Retractable Roof',
    },
  ];

  return (
    <SectionContainer>
      <SectionTitle>Service type</SectionTitle>
      <SectionBody>
        <SectionLine>
          <FormikPremiumInput
            label="Type"
            showErrors={showErrors}
            customHasError={hasVehicleTypeError}
            name={`order_data.service_type.vehicle_type`}
            type={'select'}
            isDisabled={isReadOnly}
            isRequired={true}
            availableOptions={[
              {
                value: 'Small van (max. 400kg)',
                label: 'Small van (max. 400kg)',
              },
              {
                value: 'Van (max. 800kg)',
                label: 'Van (max. 800kg)',
              },
              {
                value: 'Box Van (max. 800kg)',
                label: 'Box Van (max. 800kg)',
              },
              {
                value: 'Sprinter - Large van (max. 1200kg)',
                label: 'Sprinter - Large van (max. 1200kg)',
              },
              {
                value: 'Light rigid (max. 3.5Tn)',
                label: 'Light rigid (max. 3.5Tn)',
              },
              {
                value: 'Heavy rigid (max. 20Tn)',
                label: 'Heavy rigid (max. 20Tn)',
              },
              {
                value: 'FTL (max. 24Tn) Tautliner Standard',
                label: 'FTL (max. 24Tn) Tautliner Standard',
              },
              {
                value: 'FTL (max. 24Tn) Tautliner Mega',
                label: 'FTL (max. 24Tn) Tautliner Mega',
              },
            ]}
          />
        </SectionLine>
        <SectionLine>
          <SpecialLabel>
            <img alt="Vehicle details icon" src={VehicleDetailsIcon} />
            <SpecialLabelText>Vehicle details</SpecialLabelText>
          </SpecialLabel>
        </SectionLine>
        <SectionLine>
          <CheckboxsContainer>
            {availableVehicleDetails.map((s) => (
              <Checkbox
                key={s.value}
                name="order_data.service_type.vehicle_details"
                value={s.value}
                label={s.label}
                isDisabled={isReadOnly}
                backgroundVariant={'grey200'}
              />
            ))}
          </CheckboxsContainer>
        </SectionLine>
      </SectionBody>
    </SectionContainer>
  );
};
